export const writeReviews = {
    mySummary: {
        title: "Taken Lectures",
        written: "My Reviews",
        likes: "likes",
        selectPlaceholder: "Please select a lecture",
    },
    write: {
        title: "Write Reviews - {{lectureName}}",
        related: "Related Reviews - {{lectureName}}",
        edit: "Edit",
    },
    hallOfFameFeed: {
        title: "Hall of Fame - {{year}}<space/>{{semester}}",
        total: "Total Reviews",
    },
    likedReviews: {
        title: "My Liked Reviews",
    },
    tabs: {
        write: "Write Reviews",
        hallOfFameFeed: "Hall of Fame",
        recentFeed: "Fresh Reviews",
        liked: "My Liked Reviews",
    },
}
